import { Box } from '@mui/material';
import { createMRTColumnHelper } from 'material-react-table';
import React from 'react';
import { format } from 'date-fns';
import commaNumber from 'comma-number';
import { useNavigate } from 'react-router-dom';
import CummonTable from '../../Common/CummonTable';

const BookingList = ({ data, pageSize }) => {
  const navigate = useNavigate();
  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor('bookingId', {
      header: 'BookingId',
      Cell: ({ row }) => (
        <button
          style={{
            background: 'var(--primary-color)',
            borderRadius: '5px',
            padding: '2px 10px',
            width: '120px',
            cursor: 'pointer',
            border: 'none',
            color: 'var(--white)',
          }}
          disabled={row.original.status === 'Cancelled' ? true : false}
          onClick={() => sendToQueuesDetails(row.original)}
        >
          {row.original.bookingId}
        </button>
      ),
    }),
    columnHelper.accessor('status', {
      header: 'Status',
      Cell: ({ row }) => (
        <Box className={`${row.original.status?.toLowerCase()}-btn`}>
          {row.original.status}
        </Box>
      ),
    }),
    columnHelper.accessor('triptype', {
      header: 'Trip Type',
      size: '10px',
    }),
    columnHelper.accessor('pnr', {
      header: 'PNR',
      size: 40,
    }),
    columnHelper.accessor('carrier', {
      header: 'Carrier',
      size: 200,
    }),
    columnHelper.accessor('depfrom', {
      header: 'From-To',
      Cell: ({ row }) => ` ${row.original.depfrom} - ${row.original.arrto}`,
    }),
    columnHelper.accessor('totalpax', {
      header: 'pax',
      size: 20,
      Cell: ({ row }) => {
        return <Box pl={2}>{row.original.totalpax}</Box>;
      },
    }),

    columnHelper.accessor('flightdate', {
      header: 'Depart Date',
      size: 20,
      Cell: ({ row }) =>
        `${
          row.original?.flightdate !== '' || 'undefined' || null
            ? format(new Date(row.original?.flightdate), 'dd MMM yy hh:mm')
            : 'Fly Date'
        }`,
    }),
    columnHelper.accessor('created_at', {
      header: 'Booking Date',
      Cell: ({ row }) =>
        `${
          row.original?.created_at !== '' || 'undefined' || null
            ? format(new Date(row.original?.created_at), 'dd MMM yy hh:mm')
            : 'Booked Date'
        }`,
    }),

    columnHelper.accessor('name', {
      header: 'Passenger Name',
    }),
    columnHelper.accessor('grossfare', {
      header: 'Total Fare',
      Cell: ({ row }) =>
        `${commaNumber(row.original.grossfare) + 'AED' || 'Gross Cost'}`,
    }),
  ];
  const sendToQueuesDetails = (items) => {
    navigate(`/dashboard/bookingdetails/${items?.uid}`, {
      state: {
        data: items,
      },
    });
  };

  return (
    <div>
      <Box
        sx={{
          boxSizing: 'border-box',
        }}
      >
        <CummonTable
          data={data}
          columns={columns}
          pageSize={pageSize ? pageSize : 5}
        />
      </Box>
    </div>
  );
};

export default BookingList;
